import { throttle } from 'throttle-debounce';
import Flicikity from 'flickity';
import 'flickity-fade';

export function init() {
	const hero = document.querySelector('.js-hero');
	const image = hero ? hero.querySelector('.js-hero-image') : false;
	const carousel = hero ? hero.querySelector('.js-hero-carousel') : false;
	const video = hero ? hero.querySelector('.js-hero-video') : false;
	const videoControls = document.querySelector('.js-hero-video__controls');


	if (!(image || video || carousel)) {
		return;
	}

	calcLayout();

	let fl;

	if (carousel) {
		fl = new Flicikity(carousel, {
			autoPlay: 6000,
			setGallerySize: false,
			prevNextButtons: false,
			fade: true,
			lazyLoad: true,
		});
		fl.pausePlayer();
	} else if (video) {
		video.addEventListener('loadedmetadata', animate);
	}

	if (image) {
		if (image.complete) {
			animate();
		} else {
			image.addEventListener('load', animate);
		}
	}

	window.addEventListener('resize', throttle(1000, calcLayout));

	function animate() {
		window.requestAnimationFrame(() => hero.classList.add('animate'));
		setTimeout(() => {
			if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
				if (carousel) {
					fl.unpausePlayer();
				} else if (video) {
					video.play();
					videoControls.classList.add('is-playing');
				}
			}
			if (video) {
				revealvideoControls();
			}
			if (video || carousel) {
				window.requestAnimationFrame(() => hero.classList.add('animate-h1'));
			}
		}, 4500);
	}

	function calcLayout() {
		let windowHeight = document.documentElement.clientHeight;
		let headerHeight = document.querySelector('.js-header').clientHeight;

		hero.style.height = `${windowHeight - headerHeight}px`;
	}

	function revealvideoControls() {
		let videoControls = document.querySelector('.js-hero-video__controls');
		videoControls.classList.add('c-hero-video__controls--reveal');
	}

	if (videoControls) {
		let videoButtonPlay = document.querySelector('.js-hero-video__button--play');
		let videoButtonSound = document.querySelector('.js-hero-video__button--sound');
		videoButtonPlay.addEventListener('click', toggleVideoPlay);
		videoButtonSound.addEventListener('click', toggleVideoSound);
	}

	function toggleVideoPlay() {
		if (!video) {
			return;
		}

		if (video.paused) {
			video.play();
			videoControls.classList.add('is-playing');
		} else {
			video.pause();
			videoControls.classList.remove('is-playing');
		}
	}

	function toggleVideoSound() {
		if (!video) {
			return;
		}

		console.log(video.muted);
		if (video.muted !== false) {
			video.muted = false;
			videoControls.classList.add('is-sound');
		} else {
			video.muted = true;
			videoControls.classList.remove('is-sound');
		}
	}
}
